import cn from 'classnames'
import * as React from 'react'

import styles from './icon.module.scss'
import { ReactComponent as CrossSvg } from './cross.svg'
import { ReactComponent as CheckSvg } from './check.svg'
import { ReactComponent as NotIncludedSvg } from './not-included.svg'
import { ReactComponent as ArrowSvg } from './arrow.svg'
import { ReactComponent as PlusSvg } from './plus.svg'
import { ReactComponent as MinusSvg } from './minus.svg'

interface IIconProps extends React.SVGAttributes<SVGElement> {
  active?: boolean
  theme?: 'success' | 'danger' | 'gray' | 'dark' | 'brand'
}

function icon(SvgComponent: React.FunctionComponent<React.SVGProps<SVGSVGElement>>) {
  const Icon = ({ active, theme = 'gray', className, ...props }: IIconProps) => (
    <SvgComponent
      {...props}
      className={cn(
        styles.root,
        styles[theme],
        active !== undefined && (active ? styles.success : styles.gray),
        className
      )}
    />
  )

  return Icon
}

const CheckIcon = icon(CheckSvg)
const CrossIcon = icon(CrossSvg)
const NotIncludedIcon = icon(NotIncludedSvg)
const ArrowIcon = icon(ArrowSvg)
const PlusIcon = icon(PlusSvg)
const MinusIcon = icon(MinusSvg)

export { CheckIcon, CrossIcon, NotIncludedIcon, ArrowIcon, PlusIcon, MinusIcon }
